import { Select } from '@/components/ui/Select'
import { Skeleton } from '@/components/ui/Skeleton'
import { useSemesterKeuze } from '@/lib/semester-context'

export function SemesterKiezer() {
  const { semesterId, semesters, isLoading, kies } = useSemesterKeuze()

  if (isLoading) return <Skeleton className="h-9 w-48 rounded-lg" />
  if (semesters.length === 0) return null

  return (
    <Select
      value={semesterId}
      onValueChange={kies}
      options={semesters.map((semester) => ({ value: semester.id, label: semester.naam }))}
      className="w-full min-w-0 sm:w-56"
      placeholder="Kies een semester"
      searchPlaceholder="Zoek semester"
    />
  )
}
